/**
 * 环境缓存控制工具
 * 用于在同一域名下区分不同环境的缓存
 */

// 从URL中获取当前环境
const getEnvFromUrl = (): string => {
  const url = window.location.href;
  
  if (url.includes('/dev/')) {
    return 'development';
  }
  if (url.includes('/local/')) {
    return 'local';
  }
  if (url.includes('/uat/')) {
    return 'test';
  }
  // 默认为生产环境
  return 'production';
};

// 生成缓存版本号
const generateCacheVersion = (): string => {
  const env = getEnvFromUrl();
  const timestamp = new Date().toISOString().split('T')[0]; // 使用日期作为版本号的一部分
  return `${env}-${timestamp}`;
};

// 为资源URL添加缓存破坏参数
export const addCacheBuster = (url: string): string => {
  const cacheVersion = generateCacheVersion();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${cacheVersion}`;
};

// 初始化缓存控制
export const initCacheControl = (): void => {
  const env = getEnvFromUrl();
  
  // 在localStorage中存储当前环境
  localStorage.setItem('bee-env', env);
  
  // 为不同环境设置不同的localStorage前缀
  const storagePrefix = `bee-${env}-`;
  
  // 将环境信息添加到文档中，方便调试
  document.documentElement.dataset.env = env;
  
  console.log(`[Cache Control] Environment: ${env}, Storage Prefix: ${storagePrefix}`);
};

// 获取带环境前缀的localStorage键名
export const getPrefixedKey = (key: string): string => {
  const env = getEnvFromUrl();
  return `bee-${env}-${key}`;
};

// 带环境前缀的localStorage操作封装
export const envStorage = {
  getItem(key: string): string | null {
    return localStorage.getItem(getPrefixedKey(key));
  },
  setItem(key: string, value: string): void {
    localStorage.setItem(getPrefixedKey(key), value);
  },
  removeItem(key: string): void {
    localStorage.removeItem(getPrefixedKey(key));
  },
  clear(): void {
    // 只清除当前环境的存储项
    const env = getEnvFromUrl();
    const prefix = `bee-${env}-`;
    
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    });
  }
};

export default {
  initCacheControl,
  addCacheBuster,
  envStorage,
  getEnvFromUrl
};